// extracted by mini-css-extract-plugin
module.exports = {"skeletonContainer":"SidebarSelectionSkeleton_skeletonContainer__Pl7tL","row":"SidebarSelectionSkeleton_row__AF4Qi"};